function ajaxSubmitCart() {
  var formElement2 = document.querySelector('#cart');
  $cart = $("#cart");
  $.ajax({
    data: window.FormData ? new FormData(formElement2) : formElement2.serialize(),
    contentType : false,
    processData : false,
    url: '/cart/update.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    success: function (data) {
      refreshCart(data);
    },
    error: function() {
      alert('通信でエラーが発生しました。しばらく経ってから再度お試しください。')
    }
  });
}

function ajaxUpdateCart(lineID, quantity, parent) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: { quantity: quantity, line: lineID },
    success: function (data) {
      refreshCart(data);

      var lineIDIndex = lineID - 1;
	    var $input = parent.find("input[data-line-id='" + lineID + "']");

      //check to see if there are correct amount of products in array
      if (typeof data.items[lineIDIndex] === "undefined"){
        var updated_quantity = 0;
      } else {
        var updated_quantity = data.items[lineIDIndex].quantity;
      }

      if(quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          items_left_text = "個しか在庫がありません";
        } else {
          items_left_text = "個しか在庫がありません";
        }

        $('.warning--quantity').remove();

        var warning = '<div class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</div>';

        $input.parent().next().append(warning);
        $input.val(updated_quantity);
      }
      if(window.BOLD && BOLD.common && BOLD.common.eventEmitter){
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
      }
    }
  });
}

function refreshCart(cart) {
  //if(window.BOLD && BOLD.common && BOLD.common.cartDoctor && typeof BOLD.common.cartDoctor.fix === 'function'){
  //  cart = BOLD.common.cartDoctor.fix(cart);
  //}
  location.reload();
/*
  //console.log('cart', cart);

  $cartBtn = $(".cart-button span");
  if ($cartBtn && $cartBtn.length) {
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var $cart = $("#cart ul");

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));
    $cart.find('li:not(:first)').remove();

    if (cart.item_count == 0) {
      $cart.append('<li class="empty_cart">カートは空です</li>');
    } else {
      $.each(cart.items, function(index, item) {
        var line_id = index + 1;

        cart_items_html += `
<div class="row">
<div class="col-md-3 col-5">`

  if (item.image) {
    //cart_items_html += '<div class="cart_image">' +
    //    '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
    //  '</div>';
    cart_items_html += `<a href=""><img src="//k-3b.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_300x.gif" alt="" /></a>`
  }


      cart_items_html += `</div>
<div class="col-md-6 col-7">
<a href=""></a>`
if(item.properties) {
  $.each(item.properties, function(title, value) {
    if (value && !title.match(/^_/)) {
      cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
    }
  });
}
cart_items_html += `<div>
<span class="bold_cart_item_total-wrapper"><span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_total" style="display:none !important;"></span><small>(incl.tax)</small></span>
</div>
</div>
<div class="col-md-3 col-12 cart-quantity">
<p id="quantity_">
<i class="minus fas fa-minus"></i>
<input type="number" min="0" size="3" maxlength="3" class="quantity" name="updates[]" id="updates_" value="" data-line-id=""  />
<i class="plus fas fa-plus"></i>
</p>
</div>
</div>`




      //  cart_items_html += '<div class="price"><span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></div></div></a></li>';
      //});

      cart_items_html += '<li class="mm-label">' +
          '<p class="mm-counter price"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></p>' +
          '<a href="/cart">' +
            '<strong>小計</strong>' +
          '</a>' +
        '</li>' +
        '<li class="mm-subtitle clearfix">';

        

        

        cart_items_html += '<input type="submit" class="action_button full-width" value="チェックアウト" />' +
        
        '</li>';

      $cart.append(cart_items_html);
      $cart.find('li.cart_item:last').addClass('last_cart_item');

      
    }
  }
  */

  // if(window.BOLD && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function'){
  //   BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', cart);
  // }
}
